import React from 'react';
import {Alert} from "antd";

function ExamReportCard({answer}) {
    return (

        <div>
                <Alert showIcon={true} type={answer?.win ? 'success' : 'error'} className={'ui-iransansX'}
                       message={'کارنامه شما صادر شد!'}
                       description={<>
                               <div className="text-right">
                                       <table>
                                               <tbody>
                                               <tr>
                                                       <th>تعداد سوالات آزمون</th>
                                                       <td>
                                                           <span className={'mx-2'}>{answer?.report?.countTotalItem}</span>
                                                           <span className={'mx-1 text-gray-600 text-xs'}>سوال</span>
                                                       </td>
                                               </tr>
                                               <tr>
                                                       <th>تعداد پاسخ‌های ارسال شده</th>
                                                       <td>
                                                           <span className={'mx-2'}>{answer?.report?.countAnsweredItem}</span>
                                                           <span className={'mx-1 text-gray-600 text-xs'}></span>
                                                       </td>
                                               </tr>
                                               <tr>
                                                       <th>تعداد پاسخ‌های صحیح</th>
                                                       <td>
                                                           <span className={'mx-2'}>{answer?.report?.countCorrectItem}</span>
                                                           <span className={'mx-1 text-gray-600 text-xs'}></span>
                                                       </td>
                                               </tr>
                                               <tr>
                                                       <th>جمع امتیاز کسب شده</th>
                                                       <td>
                                                           <span className={'mx-2'}>{answer?.score}</span>
                                                           <span className={'mx-1 text-gray-600 text-xs'}>امتیاز</span>
                                                       </td>
                                               </tr>
                                               <hr className={'my-2'} />
                                               <tr>
                                                       <th>وضعیت قبولی</th>
                                                       <td><span className={'mx-2 font-bold'}>

                                                               {answer?.win ? 'قبول': 'مردود'}
                                                       </span></td>
                                               </tr>
                                               </tbody>
                                       </table>
                               </div>
                       </>}/>

        </div>
    );
}

export default ExamReportCard;